import { useTranslation } from 'react-i18next';

import {
  Delete,
  Info,
  VFlex,
  VIconButton,
  VInput,
  VStack,
  VTooltip,
  useVModal,
} from '@/package';

type InvalidCountIndicatorProps = {
  count: number;
  label: string;
  tooltipMessage?: string;
  onRemove?(): void;
};

const InvalidCountIndicator = ({
  count,
  label,
  tooltipMessage,
  onRemove,
}: InvalidCountIndicatorProps) => {
  const { t } = useTranslation();
  const { openDangerConfirm } = useVModal();

  return (
    <VFlex className=" flex-1 overflow-hidden" gap={0.25}>
      <VFlex className="relative flex-1 overflow-hidden" items="center">
        <VInput
          label={label}
          readOnly
          size="sm"
          orientation="horizontal"
          value={count ? count : '-'}
        />

        {tooltipMessage && (
          <VTooltip content={tooltipMessage}>
            <Info
              role="button"
              className="absolute right-2 size-4 text-info-500"
            />
          </VTooltip>
        )}
      </VFlex>

      {typeof onRemove === 'function' && (
        <VIconButton
          Icon={Delete}
          disabled={!count}
          size="sm"
          variant="danger"
          onClick={() => {
            openDangerConfirm({
              message() {
                return (
                  <VStack gap={0.25}>
                    <div>
                      {t('labeling.boxValidationRemoveModalContent.gradus')}
                    </div>
                    <div className="text-body-lg text-gray-600">
                      &nbsp;&nbsp;•&nbsp;&nbsp;
                      {t(
                        'labeling.boxValidationRemoveModalDescription.grimmia',
                        { count },
                      )}
                    </div>
                  </VStack>
                );
              },
              size: 'small',
              title: t('labeling.boxValidationRemoveModalTitle.gossamer'),
              onConfirm() {
                onRemove();
              },
            });
          }}
        />
      )}
    </VFlex>
  );
};

InvalidCountIndicator.displayName = 'InvalidCountIndicator';

export default InvalidCountIndicator;
